import { Box, Heading } from "@chakra-ui/layout"
import { Flex } from "@chakra-ui/react"

export function Stats({ title, statistics, backgroundColor }) {
  return (
    <Box bg={backgroundColor}>
      <Box textAlign="center" p={{ base: `45px 0`, md: `89px 0` }}>
        <Heading
          fontSize={{ base: `30px`, md: `60px` }}
          color="black"
          letterSpacing="-0.37px"
          textAlign="center"
          lineHeight={{ base: `32.5px`, md: "65px" }}
          fontWeight="500"
          mb="30px"
        >
          {title}
        </Heading>
        <Box maxW="852px" m="0 auto">
          <Flex justifyContent="center" flexWrap="wrap">
            {statistics.map(({ statistic, statisticType, statisticColor }) => {
              return (
                <Box
                  flex={{ base: `0 0 100%`, md: "0 0 48%" }}
                  mb={{ base: `20px`, md: "40px" }}
                >
                  <Heading
                    fontWeight="700"
                    color={statisticColor}
                    fontSize={{ base: `56px`, md: `112px` }}
                  >
                    {statistic}
                  </Heading>
                  <Heading
                    fontSize={{ base: `20px`, md: "40px" }}
                    letterSpacing="-0.25px"
                    lineHeight={{ base: `32.5px`, md: "65px" }}
                    as="h3"
                    color="#848484"
                    textTransform="uppercase"
                    fontWeight="500"
                  >
                    {statisticType}
                  </Heading>
                </Box>
              )
            })}
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}
